
import { defineComponent, PropType } from 'vue'
import { similarSentenceInfo } from '@/api/assist'
import Credible from '../list/credible.vue'

export default defineComponent({
  props: {
    similarSentenceList: {
      type: Array as PropType<similarSentenceInfo[]>,
      default: () => [],
    },
    paperId: {
      type: String,
      default: '',
    },
  },
  components: {
    Credible,
  },
  setup() {
    const goDetail = (sentenceId: string) => {
      window.open(`/topicDetail/${sentenceId}`, '_blank')
    }

    return {
      goDetail,
    }
  },
})
